export default __webpack_public_path__ + "static/outside-7f0e182e4b8fb534ad56856566074d25.jpg";